import $ from "jquery"

class Menu{

    MenuItem
    Wrap    

    constructor ( idMenuItem , IdWrap ) {
        this.MenuItem = idMenuItem
        this.Wrap = IdWrap

        $(window).on( 'click' , e => {
            this.closeMenu()
        })

        $(document).on( 'click' , this.MenuItem , e => {
            e.stopPropagation();
            //if ( ! $( e.currentTarget ).hasClass( 'current_page_item' ) ){
                this.toggleMenu()
            //}
        }) 
        
        $(document).on( 'click' , '.current_page_item a' , e => {
            e.preventDefault()
        })
    }

    toggleMenu () {
        $(this.Wrap).toggleClass('show')
        $(this.MenuItem + ' a').toggleClass('!text-primary')
    }

    closeMenu () {
        $(this.Wrap).removeClass('show')
        $(this.MenuItem + ' a').removeClass('!text-primary')
    }


}

export {Menu};